import { useQuery } from 'react-query'
import { type BankDataDomain } from '../../../../types/domain/expert-domain'
import { api } from '../../../api'

const fetchBankData = async (id: number) => {
  const response = await api.get(`/experts/${id}/bank-data`)
  return response.data
}

export const useBankDataQuery = (id: number) => {
  return useQuery<BankDataDomain>(['expert', id, 'bank-data'], () =>
    fetchBankData(id), { refetchOnWindowFocus: false, staleTime: 1000 * 60 * 60 * 1 } // 1h
  )
}
